// src/modules/app-views/account/pages/Init/modals/TeamInvitationModal/Step3.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Alert } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const RbacStepContent = () => (
  <Alert
    type="info"
    showIcon
    title={translateX('access_control')}
    description={translateX('coming_soon_resource')}
    style={{ marginTop: 16 }}
  />
);

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
const rbacStep = ({ foundProfile }) => ({
  stepTitle: 'RBAC',
  stepTooltip: 'set_access_permissions',
  content: <RbacStepContent />,
  isConfirmStep: true,
  // Hide this step if profile is owner or keyUser (both have full access, no RBAC needed)
  hidden: ({ form }) => {
    const profile = form?.getFieldValue('profile');
    return ['owner', 'keyUser'].includes(profile);
  },
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default rbacStep;
